import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Contract } from "@ethersproject/contracts";
import { getNetwork } from "@ethersproject/networks";
import { getDefaultProvider } from "@ethersproject/providers";
import { TokenAmount } from "./entities/fractions/tokenAmount";
import { Pair } from "./entities/pair";
import IPancakePair from "./abis/IPancakePair.json";
import invariant from "tiny-invariant";
import ERC20 from "./abis/ERC20.json";
import { ChainId } from "./constants";
import { Token } from "./entities/token";
var TOKEN_DECIMALS_CACHE = _define_property({}, ChainId.BSC, {
    "0xE0B7927c4aF23765Cb51314A0E0521A9645F0E2A": 9
});
/**
 * Contains methods for constructing instances of pairs and tokens from on-chain data.
 */ export var Fetcher = /*#__PURE__*/ function() {
    "use strict";
    function Fetcher() {
        _class_call_check(this, Fetcher);
    }
    /**
   * Fetch information for a given token on the given chain, using the given ethers provider.
   * @param chainId chain of the token
   * @param address address of the token on the chain
   * @param provider provider used to fetch the token
   * @param symbol optional symbol of the token
   * @param name optional name of the token
   */ Fetcher.fetchTokenData = function fetchTokenData(chainId, address) {
        var provider = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : getDefaultProvider(getNetwork(chainId)), symbol = arguments.length > 3 ? arguments[3] : void 0, name = arguments.length > 4 ? arguments[4] : void 0;
        return _async_to_generator(function() {
            var ref, parsedDecimals, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(typeof (TOKEN_DECIMALS_CACHE === null || TOKEN_DECIMALS_CACHE === void 0 ? void 0 : (ref = TOKEN_DECIMALS_CACHE[chainId]) === null || ref === void 0 ? void 0 : ref[address]) === "number")) return [
                            3,
                            1
                        ];
                        _tmp = TOKEN_DECIMALS_CACHE[chainId][address];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            new Contract(address, ERC20, provider).decimals().then(function(decimals) {
                                TOKEN_DECIMALS_CACHE = _object_spread_props(_object_spread({}, TOKEN_DECIMALS_CACHE), _define_property({}, chainId, _object_spread_props(_object_spread({}, TOKEN_DECIMALS_CACHE === null || TOKEN_DECIMALS_CACHE === void 0 ? void 0 : TOKEN_DECIMALS_CACHE[chainId]), _define_property({}, address, decimals))));
                                return decimals;
                            })
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        parsedDecimals = _tmp;
                        return [
                            2,
                            new Token(chainId, address, parsedDecimals, symbol, name)
                        ];
                }
            });
        })();
    };
    /**
   * Fetches information about a pair and constructs a pair from the given two tokens.
   * @param tokenA first token
   * @param tokenB second token
   * @param provider the provider to use to fetch the data
   */ Fetcher.fetchPairData = function fetchPairData(tokenA, tokenB) {
        var provider = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : getDefaultProvider(getNetwork(tokenA.chainId));
        return _async_to_generator(function() {
            var address, ref, reserves0, reserves1, balances;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(tokenA.chainId === tokenB.chainId, "CHAIN_ID");
                        address = Pair.getAddress(tokenA, tokenB);
                        return [
                            4,
                            new Contract(address, IPancakePair, provider).getReserves()
                        ];
                    case 1:
                        ref = _sliced_to_array.apply(void 0, [
                            _state.sent(),
                            2
                        ]), reserves0 = ref[0], reserves1 = ref[1];
                        balances = tokenA.sortsBefore(tokenB) ? [
                            reserves0,
                            reserves1
                        ] : [
                            reserves1,
                            reserves0
                        ];
                        return [
                            2,
                            new Pair(new TokenAmount(tokenA, balances[0]), new TokenAmount(tokenB, balances[1]))
                        ];
                }
            });
        })();
    };
    return Fetcher;
}();
